//Reducer for loading filter data options
import moment from 'moment';
const laborProcessFiltersDataReducerDefaultState = {
    minDate       : moment.utc().subtract(1 ,'month').format('YYYY-MM-DD'),
    maxDate       : moment.utc().format('YYYY-MM-DD'),
    isLoaded      : false,
    isErrorsParts : false
};

export default (state = laborProcessFiltersDataReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_IS_LOADED_LABOR_PROCESS':
            return {
                ...state,
                isLoaded : action.isLoaded
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/Reducers/laborProcessFiltersData.js